import { showErrorNotification, showSuccessNotification } from '../../global/notifications';

let _selectedPlanAssignmentId = null;
let _selectedEmployee = null;
let _areaConfigWindow = null;

let _k_serviceCenters = null;
let $selectAllServiceCenters = null;
let _k_jobDepartments = null;
let $selectAllJobDepartments = null;

let _k_customers = null;
let $selectAllCustomers = null;
let _k_sites = null;
let $selectAllSites = null;

let _k_employees = null;
let $selectAllEmployees = null;

let $saveButton = null;

export function loadAreaConfigWindow(areaConfigWindow, selectedEmployee, selectedPlanAssignmentId) {
    _areaConfigWindow = areaConfigWindow;
    _areaConfigWindow.open().center();

    _selectedEmployee = selectedEmployee;
    _selectedPlanAssignmentId = selectedPlanAssignmentId;

    initializeServiceCenterJobDepartment();
    initializeCustomerSite();
    initializeManagementStructure();

    $saveButton = $('#save-area-config');

    $saveButton.on('click', function () {
        const data = {
            EmployeeNumber: _selectedEmployee.EmployeeNumber,
            PlanAssignmentId: _selectedPlanAssignmentId,

            SelectAllServiceCenters: $selectAllServiceCenters.prop('checked'),
            SelectedServiceCenters: _k_serviceCenters?.value(),
            SelectAllJobDepartments: $selectAllJobDepartments.prop('checked'),
            SelectedJobDepartments: _k_jobDepartments?.value(),
            SelectAllCustomers: $selectAllCustomers.prop('checked'),
            SelectedCustomers: _k_customers?.value(),
            SelectAllSites: $selectAllSites.prop('checked'),
            SelectedSites: _k_sites?.value(),
            SelectAllEmployees: $selectAllEmployees.prop('checked'),
            SelectedEmployees: _k_employees?.value(),
        }

        $.post('/Commissions/CommissionPlanAssignment/SaveAreaConfig', data, (success) => {
            if (success) {
                _areaConfigWindow.close();
                showSuccessNotification('Area configuration saved successfully')
            }
            else {
                showErrorNotification('Failed to save area configuration');
            }
        }).fail((response) => showErrorNotification(response.responseText));
    });
}

export function destroyAreaConfig() {
    $saveButton.off('click');

    if (_k_serviceCenters) {
        _k_serviceCenters.destroy();
        _k_serviceCenters = null;
        $('#serviceCenters').unwrap('.k-multiselect').show().empty();
    }
    if (_k_jobDepartments) {
        _k_jobDepartments.destroy();
        _k_jobDepartments = null;
        $('#jobDepartments').unwrap('.k-multiselect').show().empty();
    }
    if (_k_customers) {
        _k_customers.destroy();
        _k_customers = null;
        $('#customers').unwrap('.k-multiselect').show().empty();
    }
    if (_k_sites) {
        _k_sites.destroy();
        _k_sites = null;
        $('#sites').unwrap('.k-multiselect').show().empty();
    }
    if (_k_employees) {
        _k_employees.destroy();
        _k_employees = null;
        $('#employees').unwrap('.k-multiselect').show().empty();
    }

    $selectAllServiceCenters.off('change');
    $selectAllJobDepartments.off('change');
    $selectAllCustomers.off('change');
    $selectAllSites.off('change');
    $selectAllEmployees.off('change');

    $('#plan-assignment-area-config').children('.k-multiselect-wrap').remove();
}

function initializeServiceCenterJobDepartment() {
    _k_serviceCenters = $('#serviceCenters').data('kendoMultiSelect');
    $selectAllServiceCenters = $('#SelectAllServiceCenters');
    _k_jobDepartments = $('#jobDepartments').data('kendoMultiSelect');
    $selectAllJobDepartments = $('#SelectAllJobDepartments');

    if ($selectAllServiceCenters.length > 0 && _k_serviceCenters) {
        $selectAllServiceCenters.on('change', selectAllServiceCentersChange);
        selectAllServiceCentersChange();
    }
    if ($selectAllJobDepartments.length > 0 && _k_jobDepartments) {
        $selectAllJobDepartments.on('change', selectAllJobDepartmentsChange);
        selectAllJobDepartmentsChange();
    }
}

function selectAllServiceCentersChange(e) {
    if ($selectAllServiceCenters.length > 0 && $selectAllServiceCenters.prop('checked')) {
        _k_serviceCenters.value(null);
        _k_serviceCenters.enable(false);
    }
    else {
        _k_serviceCenters.enable(true)
    }
}

function selectAllJobDepartmentsChange(e) {
    if ($selectAllJobDepartments.length > 0 && $selectAllJobDepartments.prop('checked')) {
        _k_jobDepartments.value(null);
        _k_jobDepartments.enable(false);
    }
    else {
        _k_jobDepartments.enable(true)
    }
}

function initializeCustomerSite() {
    _k_customers = $('#customers').data('kendoMultiSelect');
    $selectAllCustomers = $('#SelectAllCustomers');
    _k_sites = $('#sites').data('kendoMultiSelect');
    $selectAllSites = $('#SelectAllSites');

    if ($selectAllCustomers.length > 0 && _k_customers) {
        $selectAllCustomers.on('change', selectAllCustomersChange);
        selectAllCustomersChange();
    }
    if ($selectAllSites.length > 0 && _k_sites) {
        $selectAllSites.on('change', selectAllSitesChange);
        selectAllSitesChange();
    }
}

function selectAllCustomersChange(e) {
    if ($selectAllCustomers.length > 0 && $selectAllCustomers.prop('checked')) {
        _k_customers.value(null);
        _k_customers.enable(false);
    }
    else {
        _k_customers.enable(true)
    }
}

function selectAllSitesChange(e) {
    if ($selectAllSites.length > 0 && $selectAllSites.prop('checked')) {
        _k_sites.value(null);
        _k_sites.enable(false);
    }
    else {
        _k_sites.enable(true)
    }
}

function initializeManagementStructure() {
    _k_employees = $('#employees').data('kendoMultiSelect');
    $selectAllEmployees = $('#SelectAllEmployees');

    if ($selectAllEmployees.length > 0 && _k_employees) {
        $selectAllEmployees.on('change', selectAllEmployees);
        selectAllEmployees();
    }
}

function selectAllEmployees(e) {
    if ($selectAllEmployees.length > 0 && $selectAllEmployees.prop('checked')) {
        _k_employees.value(null);
        _k_employees.enable(false);
    }
    else {
        _k_employees.enable(true)
    }
}
